const freeShipping = (window.free_shipping_threshold && window.free_shipping_threshold.value) || 399;

function updateFreeShippingBanner(totalPrice) {
    //console.log("### updateFreeShippingBanner", totalPrice);
    const cartTotal = totalPrice / 100; // Convert from cents to base currency
    const threshold = Math.max(freeShipping - cartTotal, 0);
    const progress = Math.min(Math.round((cartTotal / freeShipping) * 100), 100); // Clamp to max 100%

    const bannerElement = document.querySelector('.free-shipping-banner');
    if (!bannerElement) return;

    const bannerTexts = bannerElement.querySelectorAll('.free-shipping-banner__text');
    const priceElement = bannerElement.querySelector('.free-shipping-banner__price');
    const progressBar = bannerElement.querySelector('.free-shipping-banner__progress-bar');

    //console.error("### missing elements to update", priceElement, progressBar);

    if (!priceElement || !progressBar || bannerTexts.length < 2) return;

    if (threshold > 0) {
        // Show "Spend more to get free shipping" message
        priceElement.textContent = `${threshold.toFixed(2).replace(".", ",")} KR`;
        progressBar.style.width = `${progress}%`;

        bannerTexts[0].classList.remove('hide'); // "Spend more" message
        bannerTexts[1].classList.add('hide'); // "Free shipping achieved" message
    } else {
        // Show "You have free shipping" message
        progressBar.style.width = `100%`;

        bannerTexts[0].classList.add('hide'); // "Spend more" message
        bannerTexts[1].classList.remove('hide'); // "Free shipping achieved" message
    }
}

function fetchCartAndUpdate() {
    //console.log("### fetchCartAndUpdate");
    fetch('/cart.js')
        .then((response) => {
            if (!response.ok) throw new Error('### Failed to fetch cart data');
            return response.json();
        })
        .then((data) => {
            updateFreeShippingBanner(data.total_price);
        })
        .catch((error) => {
            console.error('### Error fetching cart data:', error);
        });
}

// Override fetch to monitor cart updates
const originalFetch = window.fetch;
window.fetch = async function (input, init) {
    const response = await originalFetch(input, init);
    const url = typeof input === 'string' ? input : input.url;
    const cartUpdateEndpoints = [
        '/cart/change',
        '/cart/change.js',
        '/cart/add',
        '/cart/add.js',
        '/cart?section_id=cart-drawer'
    ];

    //console.log("### URL", url);

    if (url && cartUpdateEndpoints.some(endpoint => url.includes(endpoint))) {
        try {
            response.clone().json().then((data) => {
                if (data?.total_price !== undefined) {
                    setTimeout(updateFreeShippingBanner(data.total_price), 400);
                } else if (data?.price !== undefined && data?.quantity !== undefined) {
                    setTimeout(fetchCartAndUpdate, 400);
                }
            });
        } catch (error) {
            console.error('### Error parsing cloned fetch response:', error);
        }
    }

    return response;
};

document.addEventListener('click', (event) => {
    if (event.target.tagName === 'BUTTON' || event.target.classList.contains('m-cart-item__remove')) {
        setTimeout(fetchCartAndUpdate, 400);
    }
});

// Initial fetch on page load
fetchCartAndUpdate();
